import { type RouteRecordRaw, createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

import home_page from '@/views/home.vue'
import home from '@/views/home/index.vue'
import download from '@/views/download/index.vue'
import faq from '@/views/faq/index.vue'
import news from '@/views/news/index.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home_page',
    component: home_page,
    children: [
      {
        path: '/',
        name: 'home',
        component: home,
      },
      {
        path: '/download',
        name: 'download',
        component: download,
      },
      {
        path: '/faq',
        name: 'faq',
        component: faq,
      },
      {
        path: '/news',
        name: 'news',
        component: news,
      },
    ],
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  next()
})

router.afterEach((to, from) => {
  const { setActivePage } = useUserStore()
  const page_name: string = (to.name || '').toString()
  setActivePage(`${page_name}`)
})

export default router
